module.exports = __webpack_public_path__ + "img/medical1.fba9c4b3.png";